const normalizeTouchData = (touchData) => {
  const normalizedData = {};
  Object.keys(touchData).forEach((key) => {
    const normalized = parseInt(touchData[key], 0);
    if (Number.isNaN(normalized)) return;
    normalizedData[key] = normalized;
  });
  return normalizedData;
};

export default normalizeTouchData;
